<template lang="jade">
  component(v-if="isInterrupt"
            slot="content"
            "is"="type_interrupt"
            ":content"="fragments[0].content")
  component(v-else
            slot="content"
            ":is"="layout"
            ":content"="fragments[0]"
            ":uid"="uid")
</template>

<script>
import dialogs from 'src/components/dialogs/index'
import containers from 'src/components/containers/index'
import type_interrupt from 'src/components/forms/interrupts/stripe'
import { api, ui } from 'src/vuex/getters'

export default {
  data () {
    return {}
  },
  computed: {
    isInterrupt () {
      return this.fragments[0].content[0].type === 'type_interrupt'
    }
  },
  props: {
    fragments: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      required: true
    },
    uid: {
      type: String,
      required: true
    }
  },
  components: {
    Tabs: require('./_layouts/tabs/set'),
    Sheet: require('./_layouts/sheets/sheet'),
    type_interrupt,
    notifications: dialogs.notifications,
    modal: containers.modal,
    login: dialogs.prompt,
    inline: containers.inline
  },
  vuex: {
    getters: { api, ui }
  }
}
</script>



// WEBPACK FOOTER //
// set.vue?185a87eb